// extracted by mini-css-extract-plugin
module.exports = {"egg-counter":"egg-counter_egg-counter___PGxo","egg-counter--icon":"egg-counter_egg-counter--icon__NkmMg","egg-counter--text":"egg-counter_egg-counter--text__1KWbj"};